<template>
    <section class="recent-posts bg-light" v-if="posts && posts.length > 0">
		<div class="posts-wrapper main-content">
            <h2 class="section-title" v-html="sectionTitle"></h2>
			<div class="inner" v-if="posts && posts.length > 0">
				<SinglePost v-for="(post, k) in posts" :key="k" :id="post.id" />
			</div>
			<p class="section-link">
				<wpLink 
                    :url="archiveSlug" 
                    :type="true"
                    v-html="link_text" />
			</p>
		</div>
	</section>
</template>

<script>
// @ is an alias to /src
import _orderby from "lodash.orderby";

import { mapGetters } from 'vuex'

import wpLink from '@/components/navigation/WpLink'
import SinglePost from '@/components/blocks/SinglePost'

export default {
	name: 'recent-posts',
	props: ['page','sectionTitle','link_text'],
	data(){
		return {
			hasMore: false,
			archiveSlug: '/' + WPVUE.post_page_slug,
		}
	},
	computed:{
		...mapGetters([
			'getPosts'
		]),
		posts(){
			let posts = []
			posts = this.getPosts()
			posts = _orderby(posts, 'date', 'asc')
			if(posts && posts.length > 2){
				posts = posts.slice(0,3)
			}
			return posts;
		}

	},
	components: {
		wpLink,
		SinglePost
	},
	mounted() {
		
	},
	methods:{
		fixLink: link => link.replace(WPVUE.home_url, ''),
	}
}
</script>

<style lang="scss">
.recent-posts{
	.post-inner{
		padding: 30px;
		@media all and (max-width: 767px){
			padding: 15px;
		}
	}
	.post-content{
		padding-left: 0;
		padding-right: 0;
		padding-top: 0;
	}
}
</style>